import React from "react";
import SettingComponent from "../../../components/Settings/Settings";
import DashboardTopSearch from "../../../components/DashboardTopSearch/DashboardTopSearch";
import Notification from "../../../components/Notification/Notification";
import AdminNotification from "../../../components/Notification/AdminNotification";
import InstructorNotification from "../../../components/Notification/InstructorNotification";
import { useSelector } from "react-redux";

const InstructorSetting = () => {
  const auth = useSelector((state) => state.auth);
  return (
    <>
      <div className="topbar mb-20 mb-lg-36">
        <div className="d-flex align-items-center justify-content-between">
          <h3 className="ad-heading-04 fw-bold mb-8">Settings</h3>
          <div className="search-wrapper d-none d-lg-flex align-items-center gap-3">
            <DashboardTopSearch />
            {auth.role === "Admin" ? (
              <AdminNotification />
            ) : auth.role === "Instructor" ? (
              <InstructorNotification />
            ) : auth.role === "Student" ? (
              <Notification />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      <SettingComponent userRole="instructor" />
    </>
  );
};

export default InstructorSetting;
